<template>
    <div>
        <v-select
                v-model="age"
                :items="items"
                label="Select Age"
        ></v-select>
        <v-btn color="primary" :disabled="age === null" @click="handleSubmitAge">Submit</v-btn>
    </div>
</template>
<script>
    export default {
        name: 'AskAge',
        computed: {
            items() {
                const items = [];
                for (let i = 1; i <= 100; i++) {
                    items.push({text: i, value: i});
                }
                return items;
            }
        },
        methods: {
            handleSubmitAge() {
                this.$emit('ageDefined', this.age);
            }
        },
        data: () => ({
            age: null,
        }),
    }
</script>